"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledAppSidebarMenuItem_Content = exports.StyledAppSidebarMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _clsx = _interopRequireDefault(require("clsx"));

var _AppSidebarMenuItemIcon = require("../AppSidebarMenuItemIcon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 35px;\n  margin-right: 35px;\n  padding: 12px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow-wrap: break-word;\n\n  ", " {\n    margin-right: 24px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: #686868;\n  cursor: pointer;\n  display: flex;\n  text-align: left;\n  border-left: 4px solid transparent;\n  font-family: 'Raleway', sans-serif;\n  font-size: 16px;\n\n  :hover, &.app-sidebar__menu-item--active {\n    color: #fff;\n    border-color: #0084ee;\n    background-color: #131313;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledAppSidebarMenuItem = _styledComponents["default"].div(_templateObject());

exports.StyledAppSidebarMenuItem = StyledAppSidebarMenuItem;

var StyledAppSidebarMenuItem_Content = _styledComponents["default"].div(_templateObject2(), _AppSidebarMenuItemIcon.StyledAppSidebarMenuItemIcon);

exports.StyledAppSidebarMenuItem_Content = StyledAppSidebarMenuItem_Content;

function AppSidebarMenuItem(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(StyledAppSidebarMenuItem, _extends({}, props, {
    className: (0, _clsx["default"])(props.className, {
      'app-sidebar__menu-item--active': props.active
    })
  }), /*#__PURE__*/_react["default"].createElement(StyledAppSidebarMenuItem_Content, null, children));
}

var _default = AppSidebarMenuItem;
exports["default"] = _default;